import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "toolbar__left filters_panel p-jc-between" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_3 = { style: {"float":"right"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Nessun elemento trovato. ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Caricamento in corso... ")
const _hoisted_8 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "p-d-flex" }
const _hoisted_11 = { class: "p-d-flex" }
const _hoisted_12 = { class: "p-d-flex" }
const _hoisted_13 = { class: "p-d-flex" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "p-d-flex" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "p-d-flex" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "p-d-flex" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "p-d-flex" }
const _hoisted_22 = { class: "p-d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableSkeleton = _resolveComponent("TableSkeleton")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_TakerAutocomplete = _resolveComponent("TakerAutocomplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_BadgeEdit = _resolveComponent("BadgeEdit")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading && !_ctx.badges && _ctx.firstLoading)
      ? (_openBlock(), _createBlock(_component_TableSkeleton, {
          key: 0,
          rows: 10,
          columns: 5
        }))
      : (_openBlock(), _createBlock(_component_DataTable, {
          key: 1,
          ref: "dt",
          value: _ctx.badges,
          lazy: true,
          loading: _ctx.loading,
          rows: 10,
          "rows-per-page-options": [10, 20, 50, 100],
          paginator: true,
          totalRecords: _ctx.totalRecords,
          "auto-layout": "",
          "striped-rows": "",
          responsiveLayout: "scroll",
          compareSelectionBy: "equals",
          stateStorage: "session",
          stateKey: _ctx.stateKey,
          onPage: _ctx.onPage,
          onSort: _ctx.onSort,
          onRowClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onRowClick($event.data)))
        }, {
          header: _withCtx(() => [
            _createVNode(_component_Panel, {
              collapsed: false,
              class: "p-mb-3",
              header: "Filtri avanzati",
              toggleable: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_Calendar, {
                    modelValue: _ctx.advFilters.from_to,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.advFilters.from_to = $event)),
                    manualInput: false,
                    showIcon: true,
                    selectionMode: "range",
                    onDateSelect: _ctx.updateFilters
                  }, null, 8, ["modelValue", "onDateSelect"]),
                  _hoisted_2,
                  _createVNode(_component_TakerAutocomplete, {
                    modelValue: _ctx.advFilters.taker,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.advFilters.taker = $event)),
                    onResultSelected: _ctx.updateFilters
                  }, null, 8, ["modelValue", "onResultSelected"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_Button, {
                      label: _ctx.$t('common.refresh'),
                      class: "p-button-outlined",
                      icon: "pi pi-refresh",
                      type: "button",
                      onClick: _ctx.updateFilters
                    }, null, 8, ["label", "onClick"]),
                    _hoisted_4,
                    _createVNode(_component_Button, {
                      label: "Export",
                      icon: "pi pi-file-excel",
                      class: "p-button-outlined",
                      onClick: _ctx.onExportClick
                    }, null, 8, ["onClick"]),
                    _hoisted_5,
                    _createVNode(_component_Button, {
                      type: "button",
                      icon: "pi pi-filter-slash",
                      label: "Reset",
                      class: "p-button-outlined",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClearFilter()))
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          empty: _withCtx(() => [
            _hoisted_6
          ]),
          loading: _withCtx(() => [
            _hoisted_7
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, { header: "Giorno" }, {
              body: _withCtx(({data}) => [
                (data.explode?.incomplete == true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.badgeDate(data)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.badgeDate(data)), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Utente" }, {
              body: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    to: _ctx.bykerLink(data),
                    target: "_blank",
                    class: "dark-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data?.entity?.business_name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Durata Totale" }, {
              body: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_11, _toDisplayString(data.explode?.hours) + " (" + _toDisplayString(data.explode?.minutes) + ") ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Rimborso" }, {
              body: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_12, _toDisplayString(data.explode?.amount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "T1" }, {
              body: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_13, [
                  _createTextVNode(_toDisplayString(data.explode?.t1) + " ", 1),
                  (data.explode?.t1 != '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "(" + _toDisplayString(data.explode?.t1m) + ")", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "T2" }, {
              body: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_15, [
                  _createTextVNode(_toDisplayString(data.explode?.t2) + " ", 1),
                  (data.explode?.t2 != '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "(" + _toDisplayString(data.explode?.t2m) + ")", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "T3" }, {
              body: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_17, [
                  _createTextVNode(_toDisplayString(data.explode?.t3) + " ", 1),
                  (data.explode?.t3 != '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "(" + _toDisplayString(data.explode?.t3m) + ")", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "TN" }, {
              body: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_19, [
                  _createTextVNode(_toDisplayString(data.explode?.tn) + " ", 1),
                  (data.explode?.tn != '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "(" + _toDisplayString(data.explode?.tnm) + ")", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Note utente" }, {
              body: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_21, _toDisplayString(data.note_user), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Note admin" }, {
              body: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_22, _toDisplayString(data.note_edit), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Azioni",
              class: "column-header-right p-text-right",
              style: {"min-width":"100px","width":"150px"}
            }, {
              body: _withCtx(({data}) => [
                _withDirectives(_createVNode(_component_Button, {
                  class: "p-button-warning p-mr-1",
                  icon: "pi pi-pencil",
                  onClick: _withModifiers(($event: any) => (_ctx.onEdit(data)), ["stop"])
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    _ctx.$t('edit'),
                    void 0,
                    { bottom: true }
                  ]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading", "totalRecords", "stateKey", "onPage", "onSort"])),
    _createVNode(_component_BadgeEdit, {
      visible: _ctx.showBadgeEditDialog.show,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showBadgeEditDialog.show = $event)),
      badge: _ctx.showBadgeEditDialog.badge,
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmBadegeEditCallback()))
    }, null, 8, ["visible", "badge"])
  ], 64))
}